import { render, staticRenderFns } from "./VCardNew.vue?vue&type=template&id=399bca86&scoped=true&"
import script from "./VCardNew.vue?vue&type=script&lang=js&"
export * from "./VCardNew.vue?vue&type=script&lang=js&"
import style0 from "./VCardNew.vue?vue&type=style&index=0&id=399bca86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399bca86",
  null
  
)

export default component.exports